// ImageKit helpers. Images hosted on your ImageKit URL endpoint are resized and converted to a
// modern format (WebP/AVIF) on the fly. Any other URL (older uploads, /banners/...) is returned
// unchanged, so old and new images can live side by side.
const ENDPOINT = (process.env.REACT_APP_IMAGEKIT_URL_ENDPOINT || '').replace(/\/+$/, '');

export const isImageKit = (src) =>
  !!ENDPOINT && typeof src === 'string' && src.startsWith(`${ENDPOINT}/`);

// One resized URL, e.g. ik(url, 600)
export function ik(src, width) {
  if (!isImageKit(src) || !width) return src;
  const base = src.replace(/([?&])tr=[^&]*&?/, '$1').replace(/[?&]$/, '');
  return `${base}${base.includes('?') ? '&' : '?'}tr=w-${Math.round(width)},f-auto`;
}

// A srcSet string for responsive images, e.g. ikSet(url, [300, 600, 900]).
// Returns undefined for non-ImageKit URLs so the attribute is simply left out.
export function ikSet(src, widths) {
  if (!isImageKit(src)) return undefined;
  return widths.map((w) => `${ik(src, w)} ${w}w`).join(', ');
}
